import * as Highstock from 'highcharts/highstock';
import {SeriesOptionsType} from "highcharts";
import {ChartService, ChartStyle } from "../../../../services/chart.service";
import {Program} from "../../../../domain/cloud-topology";

export class GaChart {
  private seriesOptions = {
    point: {
      events: {
        mouseOut: ChartService.mouseOut(),
        mouseOver: ChartService.mouseOver()
      }
    },
    dataGrouping: {
      dateTimeLabelFormats: {
        minute: ['%A, %b %e, %l:%M %P', '%A, %b %e, %l:%M %P', '-%l:%M %P (' + ChartService.timezone + ')'],
        hour: ['%A, %b %e, %l:%M %P', '%A, %b %e, %l:%M %P', '-%l:%M %P (' + ChartService.timezone + ')'],
        day: ['%A, %b %e, %l:%M %P', '%A, %b %e, %l:%M %P', '-%l:%M %P (' + ChartService.timezone + ')'],
        week: ['%A, %b %e, %l:%M %P', '%A, %b %e, %l:%M %P', '-%l:%M %P (' + ChartService.timezone + ')']
      }
    }
  };

  private chartObject: Highstock.Chart;
  private GRID_DEMAND_DER_COLOR = '#5738ff';
  private GRID_DEMAND_IESO_COLOR = '#3a7523';
  private PEAK_PROB_COLOR = '#efc042';

  constructor(chartId: string, private data: [], private program?: Program) {
    if (this.data) {
      this.chartObject = Highstock.chart( {
        rangeSelector: {
          enabled: false
        },

        navigator: {
          enabled: false
        },

        credits: {
          enabled: false
        },

        chart: {
          panning: {
            enabled: true,
            type: 'xy'
          },
          panKey: 'shift',
          backgroundColor: ChartStyle.CHART_BACKGROUND
        },

        title: {
          text: `${this.program.name} Profile`,
          align: 'center'
        },

        plotOptions: {
          series: this.seriesOptions
        },

        scrollbar: {
          enabled: false
        },
        series: this.buildSeries(),
        tooltip: {
          split: false,
          shared: true,
          dateTimeLabelFormats: {
            minute: '%A, %b %e, %l:%M %P (' + ChartService.timezone + ')',
            hour: '%A, %b %e, %l:%M %P (' + ChartService.timezone + ')',
            day: '%A, %b %e, %l:%M %P (' + ChartService.timezone + ')',
            week: '%A, %b %e, %l:%M %P (' + ChartService.timezone + ')'
          },
          pointFormatter: function () {
            const value = Highstock.numberFormat(this.y, 2, '.', ',');
            return '<span style="color:' +
              (this.series as any).color + '">\u25CF</span> ' + this.series.name + ': <b>'
              + value + '</b><br/>';
          }
        },

        xAxis: {
          dateTimeLabelFormats: {
            minute: '%l:%M %P',
            hour: '%l:%M %P'
          },
          labels: {enabled: true},
          tickLength: 0,
          plotBands: [{
            from: Date.now(),
            to: this.data['gridDemandDER'][this.data['gridDemandDER'].length - 1][0], // Last X value in series
            color: '#c8c8c8'
          }]
        },

        yAxis: [{
          opposite: false,
          title: {
            text: 'MW'
          },
          labels: {
            align: 'left',
            x: 0,
            y: -2
          }
        }, {
          opposite: true,
          min: 0,
          max: 110,
          title: {
            text: 'Peak Probability (%)'
          },
          labels: {
            align: 'left',
          }
        }]
      });
    }
  }

  resize() {
    this.chartObject.reflow();
  }

  private buildSeries() {
    const series: SeriesOptionsType[] = [];
    series.push({
      type: 'line',
      name: `System Demand Premo`,
      color: this.GRID_DEMAND_DER_COLOR,
      dashStyle: 'Solid',
      lineWidth: 4,
      data: this.data['gridDemandDER'],
      zoneAxis: 'x',
      zones: [{
        value: Date.now()
      }, {
        dashStyle: 'ShortDash'
      }]
    });

    series.push({
      type: 'line',
      name: `System Demand ISO`,
      color: this.GRID_DEMAND_IESO_COLOR,
      dashStyle: 'Solid',
      lineWidth: 4,
      data: this.data['gridDemandieso'],
      connectNulls: true,
      zoneAxis: 'x',
      zones: [{
        value: Date.now()
      }, {
        dashStyle: 'ShortDash'
      }]
    });

    series.push({
      name: `Peak Probability`,
      type: 'column',
      tooltip: {
        valueSuffix: '%'
      },
      // dashStyle: 'Solid',
      color: this.PEAK_PROB_COLOR,
      edgeWidth: 3,
      data: this.data['peakProb'],
      zoneAxis: 'x',
      yAxis: 1,
      zones: [{
        value: Date.now()
      }, {
        dashStyle: 'ShortDash'
      }]
    });

    return series;
  }
}

